import script from "./hospitalInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./hospitalInfoList.vue?vue&type=script&setup=true&lang=js"

import "./hospitalInfoList.vue?vue&type=style&index=0&id=4b22bbb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b22bbb2"]])

export default __exports__